import {match} from 'ts-pattern';

import {type VehicleSalesAction} from '@dms/api/vehicle';

export type SaleDateEditMode = 'correct' | 'direct' | 'none';

interface GetSaleDateEditModeArgs {
  isSaleActionEnabled: (action: VehicleSalesAction) => boolean;
  correctAction: VehicleSalesAction;
  directAction: VehicleSalesAction;
  canCorrect: boolean;
  canDirect: boolean;
}

export function getSaleDateEditMode(args: GetSaleDateEditModeArgs): SaleDateEditMode {
  return match({
    canCorrect: args.canCorrect && args.isSaleActionEnabled(args.correctAction),
    canDirect: args.canDirect && args.isSaleActionEnabled(args.directAction),
  })
    .returnType<SaleDateEditMode>()
    .with({canCorrect: true}, () => 'correct')
    .with({canDirect: true}, () => 'direct')
    .otherwise(() => 'none');
}
